'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export default function AndroidBridge() {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window !== 'undefined' && window.AndroidRoute) {
      const updateHistoryState = () => {
        try {
          const canGoBack = window.history.length > 1 && pathname !== '/';
          window.AndroidRoute.updateHistoryState(canGoBack);
        } catch (e) {
          console.log('History state update error:', e);
        }
      };

      updateHistoryState();

      const handlePopState = () => {
        updateHistoryState();
      };

      window.addEventListener('popstate', handlePopState);

      return () => {
        window.removeEventListener('popstate', handlePopState);
      };
    }
  }, [pathname]);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.AndroidRoute) {
      try {
        window.AndroidRoute.routeChanged(window.location.href);
        const canGoBack = window.history.length > 1 && pathname !== '/';
        window.AndroidRoute.updateHistoryState(canGoBack);
      } catch (e) {
        console.log('Pathname change error:', e);
      }
    }
  }, [pathname]);

  return null;
}
